export default "__VITE_ASSET__DpkjsaPQ__"